const userAddressesService = {
    getUserAddresses: function () {
        return fetch('/rest/storefront/userAddresses/v2/shipping')
            .then(res => res.json())
            .then(data => (data.content || []));
    },
    createAddress: function (address) {
        return fetch('/rest/storefront/users/addresses', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(address)
        })
        .then(res => {
            if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);
            return res.json();
        })
        .then(data => {
            if (!data.content) throw new Error('Unexpected response shape from createAddress');
            return data.content;
        });
    },
}

export default userAddressesService;